var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('country-code-pane',{staticClass:"pwc-country-pane",attrs:{"current":_vm.userInfo.countryCode},on:{"select":_vm.handleSelectCountry}})}
var staticRenderFns = []

export { render, staticRenderFns }